/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindAllQueryResponse, TeamsControllerFindAllQueryParams, TeamsControllerFindAll401, TeamsControllerFindAll403 } from "../../models/teamsController/TeamsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { teamsControllerFindAll } from "../../clients/teamsService/teamsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const teamsControllerFindAllQueryKey = (params: TeamsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/teams'
}, ...(params ? [params] : [])] as const;
export type TeamsControllerFindAllQueryKey = ReturnType<typeof teamsControllerFindAllQueryKey>;
export function teamsControllerFindAllQueryOptions(params?: TeamsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = teamsControllerFindAllQueryKey(params);
  return queryOptions<TeamsControllerFindAllQueryResponse, ResponseErrorConfig<TeamsControllerFindAll401 | TeamsControllerFindAll403>, TeamsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return teamsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all teams for the current user
 * {@link /api/v1/teams}
 */
export function useTeamsControllerFindAll<TData = TeamsControllerFindAllQueryResponse, TQueryData = TeamsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TeamsControllerFindAllQueryKey>(params?: TeamsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TeamsControllerFindAllQueryResponse, ResponseErrorConfig<TeamsControllerFindAll401 | TeamsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? teamsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...teamsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TeamsControllerFindAll401 | TeamsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}